import { createContext } from 'react';

export const DiscoverModalContainerContext = createContext<HTMLElement>(
  document.body,
);
